import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BtwButtonModule } from '@between/ng-cdk/button';
import { BtwDialogModule, BtwDialogRef, DIALOG_DATA } from '@between/ng-cdk/dialog';
import { BtwLoadPanelModule } from '@between/ng-cdk/load-panel';
import { BtwTextBoxModule } from '@between/ng-cdk/text-box';
import { BtwToastModule, BtwToastService } from '@between/ng-cdk/toast';
import { BankStatementDailyDrillDownDto, GetBankStatementDailyDrillDownDto } from '../api-services/bank-statement-api/bank-statement-api.interface';
import { BtwTableModule } from '@between/ng-cdk/table';
import { BtwNumericPipe } from '@between/ng-common';
import { BankStatementApiService } from '../api-services/bank-statement-api/bank-statement-api.service';


@Component({
  selector: 'app-daily-drill-down',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BtwToastModule,
    BtwTextBoxModule,
    BtwDialogModule,
    BtwButtonModule,
    BtwLoadPanelModule,
    HttpClientModule,
    BtwTableModule
  ],
  providers: [BtwToastService, BtwNumericPipe],
  templateUrl: './daily-drill-down.component.html',
  styleUrl: './daily-drill-down.component.scss'
})
export class DailyDrillDownComponent implements OnInit {
  private readonly dialogRef: BtwDialogRef = inject(BtwDialogRef);
  private readonly toastService: BtwToastService = inject(BtwToastService);
  public btwNumericPipe: BtwNumericPipe = inject(BtwNumericPipe);
  private readonly bankStatementApiService = inject(BankStatementApiService);

  private readonly data = inject(DIALOG_DATA) as GetBankStatementDailyDrillDownDto;
  public startDate: any;
  public endDate: any;

  pageSize = 30;
  public bankStatementsDailyDrillDown: BankStatementDailyDrillDownDto[] = [];

  ngOnInit(): void {
    this.startDate = this.data.startDate.toLocaleDateString();
    this.endDate = this.data.endDate.toLocaleDateString();

    this.bankStatementsDailyDrillDown = this.bankStatementApiService.getBankStatementsDailyDrillDownMock(this.data);
  }

  getAmount(bankStatement: BankStatementDailyDrillDownDto) {
    return `${bankStatement.credit ? '+ ' : '- '}${this.btwNumericPipe.transform(bankStatement.amount, 'decimal')}`;
  }
}